import axios from 'axios'
export default {

  async add (stockData) {
    try {
      const response = await axios.post('stock/add', stockData)
      if (response.status === 200) {
        return true
      } else {
        console.log('Hubo un problema al agregar stock:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al agregar stock:', error)
      return false
    }
  },

  async listByBussines (businesId, search, page, startDate, endDate, type, limit) {
    try {
      const response = await axios.get(
        'stock/listByBusiness?id=' + businesId +
        '&search=' + search +
        '&page=' + page +
        '&startDate=' + startDate +
        '&endDate=' + endDate +
        '&limit=' + limit +
        '&type=' + type)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  },

  async listByPos (terminalId, search, page, startDate, endDate, type, limit) {
    try {
      const response = await axios.get(
        'stock/listByPos?id=' + terminalId +
        '&search=' + search +
        '&page=' + page +
        '&startDate=' + startDate +
        '&endDate=' + endDate +
        '&limit=' + limit +
        '&type=' + type)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  },

  async listByBussinesExcel (businesId, search, page, startDate, endDate, type, limit) {
    try {
      const response = await axios.get(
        'stock/listByBusinessExcel?id=' + businesId +
        '&search=' + search +
        '&page=' + page +
        '&startDate=' + startDate +
        '&endDate=' + endDate +
        '&limit=' + limit +
        '&type=' + type)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  },

  async listByPosExcel (terminalId, search, page, startDate, endDate, type, limit) {
    try {
      const response = await axios.get(
        'stock/listByPosExcel?id=' + terminalId +
        '&search=' + search +
        '&page=' + page +
        '&startDate=' + startDate +
        '&endDate=' + endDate +
        '&limit=' + limit +
        '&type=' + type)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  },

  async editNote (id, note) {
    try {
      const response = await axios.post('stock/note',
        { _id: id, note: note }
      )
      if (response.status === 200) {
        return true
      } else {
        console.log('Hubo un problema al editar stock:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al agregar stock:', error)
      return false
    }
  },

  async delete (id) {
    try {
      const response = await axios.post('stock/delete',
        { _id: id }
      )
      if (response.status === 200) {
        return true
      } else {
        console.log('Hubo un problema al eliminar stock:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al agregar stock:', error)
      return false
    }
  }
}
